/** m:ss from milliseconds, e.g. 3500 -> "0:03". */
export function formatClock(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = String(totalSeconds % 60).padStart(2, "0");
  return `${minutes}:${seconds}`;
}

/** Region label "m:ss–m:ss" for a playback window; the end is start plus length. */
export function formatRegion(startMs: number, lengthS: number): string {
  return `${formatClock(startMs)}–${formatClock(startMs + lengthS * 1000)}`;
}

/** Human byte count with one decimal above 1 KB, e.g. 1572864 -> "1.5 MB". */
export function formatBytes(bytes: number): string {
  const units = ["B", "KB", "MB", "GB"];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const digits = unit === 0 ? 0 : 1;
  return `${value.toFixed(digits)} ${units[unit] ?? "B"}`;
}

const ILLEGAL_CHARS = '\\/:*?"<>|';

/** Safe file name for a configuration: illegal path characters become underscores. */
export function safeFileName(name: string, maxLength = 80): string {
  const cleaned = [...name]
    .map((char) => (ILLEGAL_CHARS.includes(char) || char.charCodeAt(0) < 32 ? "_" : char))
    .join("")
    .trim()
    .slice(0, maxLength);
  return cleaned.length > 0 ? cleaned : "configuration";
}
